export default __webpack_public_path__ + "static/media/payment2.3c0f85e9.jpg";